import APIService from './api/api.service'

class BlogService {
  getPosts() {
    return APIService.get('/posts')
  }
  getSinglePost(slug) {
    return APIService.get('/posts/' + slug)
  }
  getPostsByCategories(slug){
    return APIService.get('/categories' + slug)
  }
}

export default new BlogService();
